import ReactGPicker from "react-gcolor-picker";
import { useDispatch, useSelector } from "react-redux";
import { setHotspotStyle } from "../../store/slices/CustomizerSlice";
import React from "react";
import { Button, Fab, Grid, makeStyles } from "@material-ui/core";
import ColorizeIcon from "@material-ui/icons/Colorize";
import { StyledSwitch } from "../styled-switch/StyledSwitch";
import "@szhsin/react-menu/dist/index.css";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

const useStyles = makeStyles(() => ({
  fab: {
    background: "linear-gradient(to top, #0072ff, #00c6ff)",
    boxShadow: "none",
  },
  innerBox: {
    background: "#ececec0d",
    borderRadius: "1rem",
  },
}));

const ColorSwatch = (props) => (
  <div className={"py-3"}>
    <Button
      color="primary"
      startIcon={<ArrowBackIosIcon />}
      onClick={props.handleBack}
    >
      {props.topic}
    </Button>
    <br />
    <br />
    <ReactGPicker
      colorBoardHeight={120}
      debounce
      debounceMS={300}
      format="rgb"
      gradient
      onChange={props.handleColorChange}
      popupWidth={300}
      showAlpha
      solid
      value={props.color}
    />
  </div>
);

const Customizer = () => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const customizer = useSelector((state) => state.customizer);

  const [currentColor, setCurrentColor] = React.useState("#000000");
  const [isSettingColor, setIsSettingColor] = React.useState(false);
  const [currentCtx, setCurrentCtx] = React.useState("");
  const [currentTopic, setCurrentTopic] = React.useState("");
  const [blur, setBlur] = React.useState(
    customizer.hotspotStyle.hotspotLabelBlur !== ""
  );
  const handleAnnotationStyleChange = (value) => {
    setCurrentColor(value);
    const newAnnotationStyle = { ...customizer.hotspotStyle };
    newAnnotationStyle[currentCtx] = value;
    dispatch(setHotspotStyle(newAnnotationStyle));
  };

  const handleBackClick = () => {
    setIsSettingColor(false);
    setCurrentCtx("");
    setCurrentTopic("");
  };

  const handleClick = (ctx, topic) => {
    setIsSettingColor(!isSettingColor);
    setCurrentCtx(ctx);
    setCurrentTopic(topic);
  };

  const switchClick = (e) => {
    setBlur(e.target.checked);
    let value = e.target.checked ? "saturate(180%) blur(20px)" : "";
    const newAnnotationStyle = { ...customizer.hotspotStyle };
    newAnnotationStyle[e.target.name] = value;
    dispatch(setHotspotStyle(newAnnotationStyle));
  };

  return (
    <>
      {isSettingColor && (
        <ColorSwatch
          topic={currentTopic}
          handleColorChange={handleAnnotationStyleChange}
          handleBack={handleBackClick}
          color={currentColor}
        />
      )}
      {!isSettingColor && (
        <div>
          <h6 className={"p-3"}>Model background</h6>
          <div className={"inner-box"}>
            <Grid
              container
              className={"p-3"}
              style={{ borderBottom: "1px solid #141414ba" }}
            >
              <Grid item xs={10}>
                Set the backdrop for model viewer
              </Grid>
              <Grid item xs={2} className={"text-center"}>
                <Fab
                  size="small"
                  color="secondary"
                  aria-label="add"
                  onClick={() =>
                    handleClick("background", "Model Viewer Background")
                  }
                  className={classes.fab}
                >
                  <ColorizeIcon />
                </Fab>
              </Grid>
            </Grid>
          </div>
          <h6 className={"p-3"}>Annotation color</h6>
          <div className={"inner-box"}>
            <Grid
              container
              className={"p-3"}
              style={{ borderBottom: "1px solid #141414ba" }}
            >
              <Grid item xs={10}>
                Annotation indicator text background
              </Grid>
              <Grid item xs={2} className={"text-center"}>
                <Fab
                  size="small"
                  color="secondary"
                  aria-label="add"
                  onClick={() =>
                    handleClick("hotspotColor", "Annotation Indicator Color")
                  }
                  className={classes.fab}
                >
                  <ColorizeIcon />
                </Fab>
              </Grid>
            </Grid>
            <Grid container className={"p-3"}>
              <Grid item xs={10}>
                Annotation indicator text color
              </Grid>
              <Grid item xs={2} className={"text-center"}>
                <Fab
                  size="small"
                  color="secondary"
                  aria-label="add"
                  onClick={() =>
                    handleClick(
                      "hotspotTextColor",
                      "Annotation Indicator Text Color"
                    )
                  }
                  className={classes.fab}
                >
                  <ColorizeIcon />
                </Fab>
              </Grid>
            </Grid>
          </div>
          <h6 className={"p-3"}>Annotation label</h6>
          <div className={classes.innerBox}>
            <Grid
              container
              className={"p-3"}
              style={{ borderBottom: "1px solid #141414ba" }}
            >
              <Grid item xs={10}>
                Annotation description text background
              </Grid>
              <Grid item xs={2} className={"text-center"}>
                <Fab
                  size="small"
                  color="secondary"
                  aria-label="add"
                  onClick={() =>
                    handleClick("hotspotLabelBgColor", "Annotation Label Color")
                  }
                  className={classes.fab}
                >
                  <ColorizeIcon />
                </Fab>
              </Grid>
            </Grid>
            <Grid
              container
              className={"p-3"}
              style={{ borderBottom: "1px solid #141414ba" }}
            >
              <Grid item xs={10}>
                Annotation description text color
              </Grid>
              <Grid item xs={2} className={"text-center"}>
                <Fab
                  size="small"
                  color="secondary"
                  aria-label="add"
                  onClick={() =>
                    handleClick(
                      "hotspotLabelTextColor",
                      "Annotation Label Text Color"
                    )
                  }
                  className={classes.fab}
                >
                  <ColorizeIcon />
                </Fab>
              </Grid>
            </Grid>
            <Grid container className={"p-3"}>
              <Grid item xs={10}>
                Add blur to annotation description
              </Grid>
              <Grid item xs={2} className={"text-center"}>
                <StyledSwitch
                  checked={blur}
                  name={"hotspotLabelBlur"}
                  onChange={switchClick}
                />
              </Grid>
            </Grid>
          </div>
        </div>
      )}
    </>
  );
};

export default Customizer;
